<template>
  <div
    class="whitelabel-option"
  >
    <h2 v-html="price.price_string" />

    <h3>
      {{ price.name }}
      <span v-if="price.owned">( Currently Active )</span>
    </h3>

    <p>{{ price.description }}</p>

    <button
      v-if="!price.owned"
      :class="[
        'button',
        loading ? 'disabled' : '',
      ]"
      @click="$emit('purchase', price)"
    >
      <i
        v-if="loading"
        class="fas fa-spinner fa-spin"
      />
      Upgrade to {{ price.name }}
    </button>

    <button
      v-if="cancelButton"
      :class="[
        'button',
        !downgrade ? 'cancel' : '',
        (loading || disabled) ? 'disabled' : '',
      ]"
      @click="cancel(price, downgrade)"
    >
      <i
        v-if="loading"
        class="fas fa-spinner fa-spin"
      />
      {{ cancelButton }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    price: {
      type: Object,
      required: true,
    },
    cancelButton: {
      type: String,
      default: null,
    },
    downgrade: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  emits: [
    'purchase',
    'cancel',
  ],
  methods: {
    cancel(price, downgrade) {
      if (!this.disabled) {
        this.$emit('cancel', price, downgrade)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .whitelabel-option {
    background: #FFFFFF;
    border: 2px solid #37B2A8;

    border-radius: 12px;
    padding: 48px 32px;
    //width: 100%; TODO: REINSTATE
    width: 50%; // TODO: REMOVE
    margin: 0 auto; // TODO: REMOVE

    > :deep(h2) {
      font-size: 2rem;
      line-height: 1.3rem;
      margin-bottom: 1rem;
      font-weight: 500;

      small {
        font-size: 1rem;
        color: #4E4E54;
      }
    }

    > h3 {
      font-weight: 500;
      font-size: 1.125rem;
    }

    > p {
      font-size: 0.875rem;
      color: #6E6E75;
    }

    .button {
      background: var(--primary-color);
      border: var(--primary-color) 1px solid;
      border-radius: 12px;
      width: 100%;
      padding: 1rem;
      color: #fff;
      font-size: 1rem;
      font-weight: 700;
      transition: .3s;

      &:hover {
        background: var(--primary-color-dark);
        border-color: var(--primary-color-dark);
      }

      &.cancel {
        background: #FFFFFF;
        border: var(--negative-color) 1px solid;
        color: var(--negative-color);

        &:hover {
          border-color: var(--negative-color-dark);
          color: var(--negative-color-dark);
        }
      }
    }
  }
</style>
